export const EMAILS_RESOURCE_NAME = 'emails';

export const SINGLE_EMAIL_FORM_NAME = 'singleEmailForm';

export const AUTOMATIONS_RESOURCE_NAME = 'automations';

export const GROUPS_RESOURCE_NAME = 'groups';

export const GROUP_FORM_NAME = 'groupForm';

export const AUTOMATION_FORM_NAME = 'automationForm';

export const AUTOMATION_METRICS_FIELDS = [{
  name: 'count_leads_total',
  label: 'Leads',
  alwaysVisible: true
}, {
  name: 'count_exited_leads_total',
  label: 'Left',
  alwaysVisible: true
}, {
  name: 'count_targeted_total',
  label: 'Targeted',
  alwaysVisible: true
}, {
  name: 'count_delivered_total',
  label: 'Delivered',
  showPercentages: true,
  alwaysVisible: true
}, {
  name: 'count_unique_confirmed_opened_total',
  label: 'Unique opens',
  showPercentages: true,
  alwaysVisible: true
}, {
  name: 'count_unique_clicked_total',
  label: 'Unique clicks',
  showPercentages: true,
  alwaysVisible: true
}, {
  name: 'count_goal_1_total',
  label: 'Primary goal',
  showPercentages: true,
  alwaysVisible: true,
  isToggle: true
}, {
  name: 'count_goal_2_total',
  label: 'Goal 2',
  showPercentages: true
}, {
  name: 'count_goal_3_total',
  label: 'Goal 3',
  showPercentages: true
}, {
  name: 'count_goal_4_total',
  label: 'Goal 4',
  showPercentages: true
}];

export const EMAIL_VARIATION_METRICS_FIELDS = AUTOMATION_METRICS_FIELDS.filter(m => (
  !["count_leads_total", "count_exited_leads_total"].includes(m.name)
));

export const BB_PERIODIC_TASKS = {
  48: "We last updated all data",
  46: "We sent the most recent emails"
};

export const HB_PERIODIC_TASKS = {
  49: "We last updated all data",
  45: "We sent the most recent emails"
};
